import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { IFooter } from '../types'
import { Downloads } from './Downloads'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import { selectModalData } from '../../../../store/selectors/modalSelectors'
import { selectLogsIsLoading } from '../../../../store/selectors/logsSelectors'

export const Footer: FC<IFooter> = ({ handleOnSubmit }) => {
    const isLoading = useAppSelector((selectLogsIsLoading))
    const data = useAppSelector(selectModalData)

    return (
        <div className="ps-4 pe-4 mt-1 pb-3">
            <div className="d-flex justify-content-end w-100 pb-2">
                <button
                    type="button"
                    className="app-btn-main app-btn-apply"
                    onClick={handleOnSubmit}
                    disabled={isLoading}
                >
                    <FormattedMessage
                        id={
                            data.productLogs
                                ? 'buttons.prepare'
                                : 'buttons.download'
                        }
                    />
                </button>
            </div>
            {data.productLogs && <Downloads />}
        </div>
    )
}
